export const SECONDS_TO_MILLI = 1000;
